import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { Logging } from '@newrelic/browser-agent/features/logging'
import { JSErrors } from '@newrelic/browser-agent/features/jserrors'
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events'
import { Ajax } from '@newrelic/browser-agent/features/ajax'

let newrelicObj
export const initNewRelic = () => {
  const { licenseKey, applicationID, accountID, environment } = newRelicConfig
  const options = {
    init: {
      session_replay: {
        enabled: true,
        block_selector: '',
        mask_text_selector: '*',
        sampling_rate: 10.0,
        error_sampling_rate: 100.0,
        mask_all_inputs: true,
        collect_fonts: true,
        inline_images: false,
        inline_stylesheet: true,
        fix_stylesheets: true,
        mask_input_options: {}
      },
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: true,
        cors_use_tracecontext_headers: true
      },
      ajax: {
        deny_list: ['bam.nr-data.net', '*.visualstudio.com', '*.linkedin.com']
      }
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: licenseKey,
      applicationID: applicationID,
      sa: 1
    },
    loader_config: {
      accountID: accountID,
      trustKey: accountID,
      agentID: applicationID,
      licenseKey: licenseKey,
      applicationID: applicationID
    },
    features: [Logging, GenericEvents, Ajax, JSErrors]
  }
  newrelicObj = new BrowserAgent(options)
  newrelicObj.setCustomAttribute('environment', environment, true)
}
export const newRelicConfig = {
  licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
  applicationID: process.env.REACT_APP_NEW_RELIC_APP_ID,
  accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
  environment: process.env.REACT_APP_ENV
}

export const newrelicAgent = () => {
  return newrelicObj
}
